import { render, staticRenderFns } from "./AbonosInserir.vue?vue&type=template&id=1f3f3352"
import script from "./AbonosInserir.vue?vue&type=script&lang=js"
export * from "./AbonosInserir.vue?vue&type=script&lang=js"
import style0 from "./AbonosInserir.vue?vue&type=style&index=0&id=1f3f3352&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports